var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFondoPorqueComprar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 266.738,
    height: 44.335,
    viewBox: "0 0 266.738 44.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1855",
    "data-name": "Grupo 1855",
    transform: "translate(-27.339 -351.665)",
    opacity: 0.247
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M685.672,192.665h-3.3V233.7H644.637V195.963h29.124v29.126H653.25v-5.314h15.2v-18.5h-18.5v27.11H677.06V192.665H641.339V237h44.333V195.963h37.739V233.7H694.285V204.576H714.8v5.314H699.6v18.5h18.5v-27.11H690.988V237h35.721V192.665H685.672ZM653.25,204.576h11.9v11.9h-11.9ZM714.8,225.089H702.9v-11.9h11.9Z",
    transform: "translate(-614 159)",
    fill: "#fff",
    opacity: 0.258
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1",
    "data-name": "Rect\\xE1ngulo 1",
    width: 4.905,
    height: 4.905,
    transform: "translate(42.747 367.073)",
    fill: "#fff",
    opacity: 0.258
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2",
    "data-name": "Rect\\xE1ngulo 2",
    width: 4.905,
    height: 4.905,
    transform: "translate(92.395 375.686)",
    fill: "#fff",
    opacity: 0.258
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M735.6,192.665h-3.3V233.7H694.568V195.963h29.126v29.126H703.181v-5.314h15.2v-18.5h-18.5v27.11h27.108V192.665H691.27V237H735.6V195.963h37.739V233.7H744.216V204.576h20.514v5.314h-15.2v18.5h18.5v-27.11H740.919V237H776.64V192.665H735.6Zm-32.423,11.911h11.9v11.9h-11.9Zm61.549,20.514h-11.9v-11.9h11.9Z",
    transform: "translate(-573.247 159)",
    fill: "#fff",
    opacity: 0.258
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3",
    "data-name": "Rect\\xE1ngulo 3",
    width: 4.905,
    height: 4.905,
    transform: "translate(133.431 367.073)",
    fill: "#fff",
    opacity: 0.258
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4",
    "data-name": "Rect\\xE1ngulo 4",
    width: 4.905,
    height: 4.905,
    transform: "translate(183.08 375.686)",
    fill: "#fff",
    opacity: 0.258
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M785.536,192.665h-3.3V233.7H744.5V195.963h29.126v29.126H753.112v-5.314h15.2v-18.5h-18.5v27.11h27.11V192.665H741.2V237h44.335V195.963h37.739V233.7H794.148V204.576h20.514v5.314h-15.2v18.5h18.5v-27.11H790.85V237h35.721V192.665H785.536Zm-32.424,11.911h11.9v11.9h-11.9Zm61.551,20.514h-11.9v-11.9h11.9Z",
    transform: "translate(-532.494 159)",
    fill: "#fff",
    opacity: 0.258
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_5",
    "data-name": "Rect\\xE1ngulo 5",
    width: 4.905,
    height: 4.905,
    transform: "translate(224.116 367.073)",
    fill: "#fff",
    opacity: 0.258
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6",
    "data-name": "Rect\\xE1ngulo 6",
    width: 4.905,
    height: 4.905,
    transform: "translate(273.764 375.686)",
    fill: "#fff",
    opacity: 0.258
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoPorqueComprar);
export default __webpack_public_path__ + "static/media/fondo_porque_comprar.84ad56b7133dbc541f7982f70d63f4c6.svg";
export { ForwardRef as ReactComponent };